import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const FeaturedPartner = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [controls, inView]);

  const universities = [
    { name: "Illinois", logo: "https://tse3.mm.bing.net/th/id/OIP.qfGjE0wiF3vfw6-igLEdiwHaBn?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Brock", logo: "https://www.eduopinions.com/wp-content/uploads/2018/09/BrockUniversity-logo.png" },
    { name: "Thompson River", logo: "https://tse1.mm.bing.net/th/id/OIP.3gW_LYTnidGtIya_fi9BZgHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Saskatchewan Polytechnic", logo: "https://tse2.mm.bing.net/th/id/OIP.6IgG7CHf63j2OhBnm4l94QHaEO?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Sault College", logo: "https://www.vmcdn.ca/f/files/sootoday/images/galleries/older/sclogonewoct09.jpg;w=470" },
    { name: "Sunni Oswego", logo: "https://scholarships2u.com/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBandEIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--49db8cdf6b62eec531e0e17531c42fffd6671e3b/SUNY_Oswego-Logo_500x500-1549391400.jpg" },
    { name: "St.Lawrence College", logo: "https://crown.edu.mm/wp-content/uploads/2021/07/St.-Lawrence-College.jpg" },
    { name: "LaSalle College", logo: "https://th.bing.com/th/id/R.e3534b1a55716391ddec2552d6184aa5?rik=sysxySh6b1573g&riu=http%3a%2f%2ftous-logos.com%2fwp-content%2fuploads%2f2018%2f06%2fCouleurs-logo-LaSalle.jpg&ehk=m%2f8YpQzn9xZRL%2f4TJYOmZzs%2fDPPhPYIwpEP%2bizeUCWA%3d&risl=&pid=ImgRaw&r=0" },
    { name: "Florida International", logo: "https://tse2.mm.bing.net/th/id/OIP.jLr52XJYfqXLCZZ6mm39RQAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "University of Massachusetts", logo: "https://tse1.explicit.bing.net/th/id/OIP.ERgUfAXNp9HabGiXeLq9PAHaHV?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "University of Nevada Reno", logo: "https://tse1.mm.bing.net/th/id/OIP.RySEULdAffey4YteYy4RlQHaHw?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "University at Buffalo", logo: "https://seeklogo.com/images/U/university-at-buffalo-logo-E45B0189A6-seeklogo.com.png" },
    { name: "Johns Hopkins", logo: "https://logos-world.net/wp-content/uploads/2023/02/Johns-Hopkins-University-Emblem.png" },
    { name: "Cleveland State University", logo: "https://tse1.mm.bing.net/th/id/OIP.SdWtURFAIP9Lywv6XnyfUwHaFj?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Herzing", logo: "https://tse1.mm.bing.net/th/id/OIP.iyVLkyYOCBWiDU8szlN4XQHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" },

    // New 11 logos
    { name: "Road Royal University", logo: "https://tse3.mm.bing.net/th/id/OIP.PDE18I-IYP944C7baAp-cgHaFa?r=0&cb=thfvnext&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Durham College", logo: "https://www.careerabroad.ca/wp-content/uploads/2016/09/Durham.png" },
    { name: "Cambrian College", logo: "https://www.vmcdn.ca/f/files/sudbury/uploadedImages/news/localNews/2024/07/cambrian-college-logo.jpg;w=960" },
    { name: "Northern College", logo: "https://tse2.mm.bing.net/th/id/OIP.KGDloSPV0Jf6fQUuTQD_1wAAAA?r=0&cb=thfvnext&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Medicine Hat College", logo: "https://tse4.mm.bing.net/th/id/OIP.FGROl6xO4amQ1XmtdJQPFAHaD4?r=0&cb=thfvnext&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Norquest College", logo: "https://tse4.mm.bing.net/th/id/OIP.wJi0sBPAnX7oOgu1eWaY1wHaB4?r=0&cb=thfvnext&rs=1&pid=ImgDetMain&o=7&rm=3" },
    { name: "Douglas College", logo: "https://www.collegesinstitutes.ca/wp-content/uploads/2022/10/1_member_logo_douglas.jpg" },
    { name: "JIBC", logo: "https://static.wixstatic.com/media/5775f7_459fd8fc355445de8ac81578d7026318~mv2.png/v1/fill/w_1080,h_1080,al_c/JIBC%201080x1080.pngg" },
    { name: "HTMI", logo: "https://htmi.ch/wp-content/uploads/2018/03/HTMI_ch_Logo-1.jpg" },
    { name: "ST. Clair", logo: "https://www.stclaircollege.ca/sites/default/files/scc-open-graph-image.jpg" },
    { name: "Sheridan", logo: "https://tse1.mm.bing.net/th/id/OIP.CGQtfYmxI2xAO7-5trsfxAHaEK?r=0&cb=thfvnext&rs=1&pid=ImgDetMain&o=7&rm=3" },
  ];

  const chunkArray = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      res.push(arr.slice(i, i + chunkSize));
    }
    return res;
  };

  const logoRows = chunkArray(universities, Math.ceil(universities.length / 3));

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
      }}
      className="bg-white py-20 px-4 sm:px-6 lg:px-12 rounded-3xl shadow-2xl border-t-8 border-red-600 relative"
    >
      <style>
        {`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          @keyframes scrollRight {
            0% { transform: translateX(-50%); }
            100% { transform: translateX(0); }
          }
          .marquee-left {
            display: flex;
            animation: scrollLeft linear infinite;
            width: max-content;
          }
          .marquee-right {
            display: flex;
            animation: scrollRight linear infinite;
            width: max-content;
          }
        `}
      </style>

      {/* Gradient fades */}
      <div className="absolute top-0 left-0 h-full w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
      <div className="absolute top-0 right-0 h-full w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            <span className="text-red-600 font-extrabold">200+</span>{" "}
            Partner Universities to live your dream life abroad
          </h2>
        </div>

        {[16, 20, 18].map((speed, rowIdx) => (
          <div key={rowIdx} className="overflow-hidden mb-6 relative">
            <div
              className={`${rowIdx % 2 === 0 ? "marquee-left" : "marquee-right"} gap-8`}
              style={{ animationDuration: `${speed}s` }}
            >
              {[...logoRows[rowIdx], ...logoRows[rowIdx]].map((uni, index) => (
                <div
                  key={`${rowIdx}-${index}`}
                  className="h-28 w-44 flex items-center justify-center bg-white p-3 border rounded-xl shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={uni.logo}
                    alt={uni.name}
                    className="max-h-20 max-w-[150px] object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default FeaturedPartner;
